import * as Actions from '../../actions'

const initialState = {
  data: {
    addresses: [],
    points: {}
  },
  isLoading: false,
  isLoaded: false,
  isUpdated: false,
  error: false
}

const user = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_USER: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false
      }
    }
    case Actions.GET_USER_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoaded: true,
        error: false
      }
    }
    case Actions.GET_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error
      }
    }

    case Actions.UPDATE_USER: {
      return {
        ...state,
        isLoading: true,
        isUpdated: false,
        error: false
      }
    }
    case Actions.UPDATE_USER_SUCCESS: {
      return {
        ...state,
        data: { ...state.data, ...action.payload },
        isLoading: false,
        isUpdated: true,
        error: false
      }
    }
    case Actions.UPDATE_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        isUpdated: false,
        error: action.error
      }
    }

    case Actions.ADD_FAVORITE_VENUE: {
      return {
        ...state,
        isLoading: true,
        isUpdated: false,
        error: false
      }
    }
    case Actions.ADD_FAVORITE_VENUE_SUCCESS: {
      return {
        ...state,
        data: { ...state.data, favoriteVenues: [...state.data.favoriteVenues, action.payload] },
        isLoading: false,
        isUpdated: true,
        error: false
      }
    }
    case Actions.ADD_FAVORITE_VENUE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        isUpdated: false,
        error: action.error
      }
    }

    case Actions.REMOVE_FAVORITE_VENUE: {
      return {
        ...state,
        isLoading: true,
        isUpdated: false,
        error: false
      }
    }
    case Actions.REMOVE_FAVORITE_VENUE_SUCCESS: {
      return {
        ...state,
        data: { ...state.data, favoriteVenues: state.data.favoriteVenues.filter(item => item.toString() !== action.payload.toString()) },
        isLoading: false,
        isUpdated: true,
        error: false
      }
    }
    case Actions.REMOVE_FAVORITE_VENUE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        isUpdated: false,
        error: action.error
      }
    }

    case Actions.LOGOUT: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.LOGOUT_SUCCESS: {
      return {
        ...state,
        data: {
          addresses: [],
          points: {}
        },
        isLoading: false,
        isLoaded: false,
        isUpdated: false,
        error: false
      }
    }
    case Actions.LOGOUT_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    default: {
      return state
    }
  }
}

export default user
